<template>
  <div>
    <p class="text-2xl mb-6">Liste des URLs de Monitoring</p>
    <v-col cols="12" class="d-flex flex-row-reverse">
      <v-btn color="primary" link :to="{ name: 'synthetic-monitoring-add-edit' }">
        <v-icon class="mr-3">{{ icons.mdiPlusBox }}</v-icon>
        Créer un nouveau monitor
      </v-btn>
    </v-col>
    <v-col cols="12">
      <url-monitors-table></url-monitors-table>
    </v-col>
  </div>
</template>

<script>
import { mdiPlusBox } from "@mdi/js";
import UrlMonitorsTable from "@/components/web-perf/synthetic-monitoring/tables/UrlMonitorsTable.vue";

export default {
  name: "SyntheticMonitoringList",
  components: {
    UrlMonitorsTable,
  },
  data() {
    return {
      icons: {
        mdiPlusBox,
      },
    };
  },
};
</script>